import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SendEmailAltaContable {

  constructor(private http: HttpClient) { }
  sendEmail(data): Observable<any> {
    return this.http.post(`${environment.urlApi}discapacidad/sendInstructivo`, data)
  }
}
